export enum TransitFrequencyInterval {
  MANY = 'many',
  DAY = 'day',
  WEEK = 'week',
}
